/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Grower_Area_Public_Load_Error_TitleInputs */

const vi_grower_area_public_load_error_title = /** @type {(inputs: Grower_Area_Public_Load_Error_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tải được thông tin vùng trồng`)
};

/**

* @param {Grower_Area_Public_Load_Error_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const grower_area_public_load_error_title = /** @type {((inputs?: Grower_Area_Public_Load_Error_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Grower_Area_Public_Load_Error_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_grower_area_public_load_error_title(inputs)
});